export enum ExtraFieldObjectTypeEnum
{
    NPS,
    TextForEvaluateAI,
    Campaign,
    CampaignDescription,
    Info,
    InfoDate
}